export default __webpack_public_path__ + "static/media/ReportIcon.7fd2c81e.svg";